
export const enumCronStatuses = {
    ["IN_PROGRESS"]: "In Progress",
    ["COMPLETED"]: "Completed",
    ["ERROR"]: "Error",
    ["WARNING"]: "Warning",
    PAUSED: "Paused",
}

export const FINANCE_TYPE = "FINANCE";
export const KIT_PRODUCTS_TYPE = "KIT_PRODUCTS_TYPE";
export const QUICKBOOKS_TYPE = "QUICKBOOKS";
export const PROFIT_REPORT_ALL = "PROFIT_REPORT_ALL";
export const PROFIT_AND_LOSS_HISTORY = "PROFIT_AND_LOSS_HISTORY";
export const SHOPIFY_AMAZON_INVENTORY = "SHOPIFY_AMAZON_INVENTORY";
export const SHOPIFY_REFUNDS = "SHOPIFY_REFUNDS";
export const META_INSIGHTS_TYPE = "META_INSIGHTS";
export const META_ADS_TYPE = "META_ADS";
export const AMAZON_SALES_REPORT = "AMAZON_SALES_REPORT";
export const BEGIN_INVENTORY = "BEGIN_INVENTORY";
export const OTB_ORDERS = "OTB_ORDERS";
export const SHOPIFY_PRODUCTS = "SHOPIFY_PRODUCTS";
export const SHOPIFY_LANDING_COST = "SHOPIFY_LANDING_COST";
export const SHOPIFY_METAFIELDS = "SHOPIFY_METAFIELDS";
export const SHOPIFY_METAFIELDS_UPDATE = "SHOPIFY_METAFIELDS_UPDATE";
export const SHOPIFY_AMAZON_SALES = "SHOPIFY_AMAZON_SALES";
export const CASH_FLOW_REPORT_ALL = "CASH_FLOW_REPORT_ALL";
export const BALANCE_SHEET_REPORT_ALL = "BALANCE_SHEET_REPORT_ALL";
export const EMAILS_TYPE = "EMAILS";
export const SHIPHERO_TOKEN_TYPE = "SHIPHERO_TOKEN";
export const CHECK_PRODUCT_SALE_STATUS_TYPE = "CHECK_PRODUCT_SALE_STATUS";
export const BILL_COM_TYPE = "BILL_COM";
export const EFFECTIVE_CAPITAL_PLAID_SYNC_TYPE = "EFFECTIVE_CAPITAL_PLAID_SYNC";
export const RECEIVED_INVENTORY_TYPE = "RECEIVED_INVENTORY";
export const RECEIVED_SHIPMENTS_TYPE = "RECEIVED_SHIPMENTS";
export const WAREHOUSE_INVENTORY_TYPE = "WAREHOUSE_INVENTORY";
export const INVENTORY_COST_CHANGE_TYPE = "INVENTORY_COST_CHANGE";
export const SHIPPING_EACH_COST_CHANGE_TYPE = "SHIPPING_EACH_COST_CHANGE";
export const EADIN_COGS_TYPE = "EADIN_COGS";
export const LOW_STOCK_ALERTS_TYPE = "LOW_STOCK_ALERTS";
export const AMAZON_FBA_LOW_STOCK_ALERTS_TYPE = "AMAZON_FBA_LOW_STOCK_ALERTS";
export const LOW_STOCK_SOLD_OUT_ALERTS_TYPE = "LOW_STOCK_SOLD_OUT_ALERTS";
export const MISSING_INVENTORY_COST = "MISSING_INVENTORY_COST";
export const PRODUCTS_TYPE = "PRODUCTS";
export const AMAZON_ORDERS_TYPE = "AMAZON_ORDERS";
export const ORDERS_RECONCILE_TYPE = "ORDERS_RECONCILE";
export const SHIPMENT_COSTS_TYPE = "SHIPMENT_COSTS";
export const BOM_PACKAGING_TYPE = "BOM_PACKAGING";
export const SOURCE_SKUS_BY_PRODUCT_TYPE = "SOURCE_SKUS_BY_PRODUCT";
export const AMAZON_MONTH_END_CLOSE_SUMMARY_TYPE = "AMAZON_MONTH_END_CLOSE_SUMMARY";
export const INBOUND_SHIPMENTS_TYPE = "INBOUND_SHIPMENTS";
export const MONTHLY_AP_PO_PAID_TYPE = "MONTHLY_AP_PO_PAID";
export const MONTHLY_PO_AP_DUE_TYPE = "MONTHLY_PO_AP_DUE";
export const MONTHLY_PO_AP_PROGRESS_TYPE = "MONTHLY_PO_AP_PROGRESS";
export const SALES_BY_PRODUCT_TYPE = "SALES_BY_PRODUCT";
export const SALES_BY_PRODUCT_BY_DAY_TYPE = "SALES_BY_PRODUCT_BY_DAY";
export const SALES_REVENUE_TYPE = "SALES_REVENUE";
export const SALES_REVENUE_MONTHLY_TYPE = "SALES_REVENUE_MONTHLY";
export const SHOPIFY_PROFIT_SUMMARY_TYPE = "SHOPIFY_PROFIT_SUMMARY";
export const SHOPIFY_PROFIT_BY_SKU_SUMMARY_TYPE = "SHOPIFY_PROFIT_BY_SKU_SUMMARY";
export const TOTAL_PRODUCT_REVENUE_TYPE = "TOTAL_PRODUCT_REVENUE";
export const KLAVIYO_TYPE = "KLAVIYO";
export const POSTSCRIPT_TYPE = "POSTSCRIPT";
export const GOOGLE_ADS_METRICS_TYPE = "GOOGLE_ADS_METRICS";
export const MICROSOFT_ADS_METRICS_TYPE = "MICROSOFT_ADS_METRICS";
export const APPLOVIN_METRICS_TYPE = "APPLOVIN_METRICS";
export const TIKTOK_ADS_METRICS_TYPE = "TIKTOK_ADS_METRICS";
export const SNAPCHAT_ADS_METRICS_TYPE = "SNAPCHAT_ADS_METRICS";
export const X_ADS_METRICS_TYPE = "X_ADS_METRICS";
export const GA4_METRICS_TYPE = "GA4_METRICS";
export const STRIPE_SYNC_TYPE = "STRIPE_SYNC";
export const ALIA_METRICS_TYPE = "ALIA_METRICS";
export const TRYBE_METRICS_TYPE = "TRYBE_METRICS";
export const SHOPIFY_TRYBE_SALES_DAILY = "SHOPIFY_TRYBE_SALES_DAILY";
export const FATHOM_MEETINGS_TYPE = "FATHOM_MEETINGS";
export const UPS_TRACKING_TYPE = "UPS_TRACKING";
export const INBOUND_TRANSIT_ALERT = "INBOUND_TRANSIT_ALERT";
export const INBOUND_RECEIVING_PUTAWAY_ALERT = "INBOUND_RECEIVING_PUTAWAY_ALERT";
export const RETURNS_SHOPIFY_SYNC = "RETURNS_SHOPIFY_SYNC";
export const RETURNS_PROCESSING_ALERT = "RETURNS_PROCESSING_ALERT";
export const CLARITY_INSIGHTS_TYPE = "CLARITY_INSIGHTS";
export const RICHPANEL_SYNC_TYPE = "RICHPANEL_SYNC";
export const MOTION_SYNC_TYPE = "MOTION_SYNC";
export const INTELLIGEMS_SYNC_TYPE = "INTELLIGEMS_SYNC";
export const DAILY_CHANNEL_METRICS_TYPE = "DAILY_CHANNEL_METRICS";
export const COMMAND_CENTER_TYPE = "COMMAND_CENTER";
export const CRON_IN_PROGRESS = "IN_PROGRESS";
export const CRON_COMPLETED = "COMPLETED";
export const CRON_ERROR = "ERROR";
export const CRON_WARNING = "WARNING";
export const BILLCOM_AP_WRITEBACK_TYPE = "BILLCOM_AP_WRITEBACK";
export const BILLCOM_PO_RECONCILIATION_REPORT_TYPE = "BILLCOM_PO_RECONCILIATION_REPORT";
export const BILLCOM_AP_WRITEBACK_STATUS_REPORT_TYPE = "BILLCOM_AP_WRITEBACK_STATUS_REPORT";
export const BILLCOM_BANK_CASH_RECON_REPORT_TYPE = "BILLCOM_BANK_CASH_RECON_REPORT";
export const EADIN_CATALOG_REPORT_TYPE = "EADIN_CATALOG_REPORT";
export const EADIN_INVENTORY_REPORT_TYPE = "EADIN_INVENTORY_REPORT";
export const AMAZON_AD_SPEND_TYPE = "AMAZON_AD_SPEND";
export const AMAZON_SETTLEMENT_FX_TYPE = "AMAZON_SETTLEMENT_FX";
export const QBO_CHANGE_LEDGER_TYPE = "QBO_CHANGE_LEDGER";
export const SHIPHERO_LOCATIONS_TYPE = "SHIPHERO_LOCATIONS";
export const WAREHOUSE_REPLENISHMENT_TYPE = "WAREHOUSE_REPLENISHMENT";
export const WAREHOUSE_CHECKLIST_DAILY_TYPE = "WAREHOUSE_CHECKLIST_DAILY";
export const WAREHOUSE_CHECKLIST_WEEKLY_TYPE = "WAREHOUSE_CHECKLIST_WEEKLY";
export const WAREHOUSE_CONSOLIDATION_WEEKLY_TYPE = "WAREHOUSE_CONSOLIDATION_WEEKLY";
export const WAREHOUSE_PICK_PACK_DAILY_TYPE = "WAREHOUSE_PICK_PACK_DAILY";
export const CUSTOMER_CARE_DAILY_TYPE = "CUSTOMER_CARE_DAILY";
export const SHIPHERO_PICK_PACK_TYPE = "SHIPHERO_PICK_PACK";
export const WAREHOUSE_DATA_GAPS_TYPE = "WAREHOUSE_DATA_GAPS";
export const AMAZON_MISSING_COST_TYPE = "AMAZON_MISSING_COST";
export const WAREHOUSE_CAPACITY_SHEET_SYNC_TYPE = "WAREHOUSE_CAPACITY_SHEET_SYNC";
export const THIRTEEN_WEEK_CASH_FLOW_REPORT_TYPE = "THIRTEEN_WEEK_CASH_FLOW_REPORT";
export const CASH_FLOW_BANK_HOLIDAYS_ROLLOVER_TYPE = "CASH_FLOW_BANK_HOLIDAYS_ROLLOVER";
